import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { GenericoService } from '../shared/services/generico.service';
import { AuthService } from '../security/auth.service';

@NgModule({
    imports: [RouterModule, CommonModule],
    declarations: [SidebarComponent],
    exports: [SidebarComponent],
    providers: [AuthService, GenericoService]
})

export class SidebarModule { }
